import React from 'react';
import PropTypes from 'prop-types';

export default function LuggageIcon({ scaleFactor = 1 }) {
  return (
   <svg
    width={32 * scaleFactor}
    height={32 * scaleFactor}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
   >
    <path
     fillRule="evenodd"
     clipRule="evenodd"
     d="M12.25 7C12.25 6.44772 12.6977 6 13.25 6H18.75C19.3023 6 19.75 6.44772 19.75 7V9.75H28.75C29.3023 9.75 29.75 10.1977 29.75 10.75V25C29.75 25.5523 29.3023 26 28.75 26H3.25C2.69772 26 2.25 25.5523 2.25 25V10.75C2.25 10.1977 2.69772 9.75 3.25 9.75H12.25V7ZM13.5 9.75H18.5V7.75C18.5 7.47386 18.2761 7.25 18 7.25H14C13.7239 7.25 13.5 7.47386 13.5 7.75V9.75ZM7.25 12.25H4.75V23.5H7.25V12.25ZM24.75 12.25H27.25V23.5H24.75V12.25Z"
     fill="#84888A"
    />
   </svg>
);
}

LuggageIcon.propTypes = {
 scaleFactor: PropTypes.number,
};
